"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.lazyAsync = void 0;
function lazyAsync(init) {
    let cache;
    let loaded = false;
    return async () => {
        if (!loaded) {
            cache = await init();
            loaded = true;
        }
        return cache;
    };
}
exports.lazyAsync = lazyAsync;
//# sourceMappingURL=lazyAsync.js.map